<template>
    <v-container id="shop-wrapper" fluid>
        <v-row column justify-center align-center>
            <v-col cols="12" class="test">
                <v-container class="shop-container pt-0">
                    <v-row>
                    <CheckoutDisabledAlert v-if="disabledCheckout && !isAuthor" />
                    </v-row>
                    <v-row column justify-center align-center>
                        <v-col v-if="facets.length > 0" cols="12" class="pa-0">
                            <!-- <client-only> -->
                            <ElasticBase
                                :facets="facets"
                                :category-tree-items="categoryTreeItems"
                            >
                                <template
                                            id="chip-wrapper"
                                            slot="selectedItem"
                                            slot-scope="{ label, remove }"
                                        >
                                            <v-chip
                                                class="mb-2 mr-2"
                                                style="background:#ffffff"
                                                outlined
                                                close
                                                @click="() => remove()"
                                                @click:close="() => remove()"
                                                >{{ label }}</v-chip
                                            >
                                </template>
                                <div
                                    slot="list"
                                    slot-scope="{ data, loadingData }"
                                    class="container pt-0 pa-0"
                                >
                                    <ElasticProductResults
                                        :product-list="data"
                                        :loadingData="loadingData"
                                    />
                                </div>
                                <template
                                    slot="Search"
                                    slot-scope="{ value, onChange }"
                                >
                                    <v-text-field
                                        :value="value"
                                        :label="localize('filterProductsByPartOrKeyword')"
                                        solo
                                        clearable
                                        hide-details
                                        class="mb-4"
                                        @change="(val) => onChange(val)"
                                    ></v-text-field>
                                </template>
                                <template
                                    slot="Categories"
                                    slot-scope="{ value, onChange }"
                                >
                                    <v-card id="shop-tour-step-0" class="mb-5">
                                        <v-card-title class="title"
                                            ><TranslatableStringComponent :tstring="{string: 'categories'}" /></v-card-title
                                        >
                                        <v-divider />
                                        <v-text-field
                                            v-model="search"
                                            :label="localize('filterCategories')"
                                            dense
                                            flat
                                            solo-inverted
                                            hide-details
                                            class="pa-4"
                                            @input="search.length>0?category=0:category=null"
                                        >
                                            <v-icon slot="append" dense>
                                                fa-times
                                            </v-icon>
                                        </v-text-field>
                                        <v-card-text
                                            v-if="categoryTreeItems.length > 0"
                                            class="pa-4"
                                        >
                                         <v-expansion-panels v-model="category" >
                                            <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <TranslatableStringComponent :tstring="{string: 'selectCategory'}" />
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-treeview
                                                :items="categoryTreeItems"
                                                hoverable
                                                dense
                                                :search="search"
                                                :filter="filter"
                                                open-on-click
                                                item-key="name"
                                                selectable
                                                :value="value || []"
                                                @input="(val) => onChange(val)"
                                            />
                                            </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                        </v-card-text>
                                    </v-card>
                                </template>
                            </ElasticBase>
                        </v-col>
                    </v-row>
                </v-container>
                <!-- <TourShop /> -->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import ElasticBase from '~/components/Elasticbase.vue'
import { getCategoryTree } from '~/util/category'
import ElasticProductResults from '~/components/ElasticProductResults.vue'
import CheckoutDisabledAlert from '~/components/CheckoutDisabledAlert.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
// import TourShop from '~/components/popups/TourShop.vue'
import mobileFlexOrder from '~/mixins/mobileFlexOrder'
import getDollarString from '~/mixins/getDollarString'
import { client } from '~/plugins/global.js'
export default {
    name: 'Shop',
    components: {
        ElasticBase,
        ElasticProductResults,
        CheckoutDisabledAlert,
        TranslatableStringComponent,
        // TourShop
    },
    mixins: [mobileFlexOrder, getDollarString],
    props: {
        filters: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            selectedCategory: [],
            categoryTree: [],
            facets: [],
            search: null,
            category:null,
            disabledCheckout: false,
        }
    },
    computed: {
        filter() {
            return this.caseSensitive
                ? (item, search, textKey) => item[textKey].includes(search)
                : undefined
        },
        ...mapGetters({
            fetchCartProducts: 'cart/fetchCartProducts',
            isAuthor: 'auth/isAuthor'
        }),
        categoryTreeItems() {
            return this.categoryTree.map((c) => {
                return {
                    id: c._id,
                    name: c.title.en,
                    children: c.subCategories.map((sc) => ({
                        id: sc._id,
                        name: sc.title.en
                    }))
                }
            })
        }
    },
    async mounted(context) {
        this.fetchFacets()
        const categoryTree = await getCategoryTree()
        this.categoryTree = categoryTree
    },
    methods: {
        async fetchFacets() {
            const groq = `*[_type == "attributeTitle" && isPublic == true] | order(title.en asc) { title, "categories": categories[]-> title.en}`
            const facets = await client.fetch(groq)
            const categoryTree = this.categoryTree
            const dynamicFacets = facets.map((f) => {
                return {
                    name: f.title.en,
                    type: 'multiple',
                    property: `attributes.${f.title.en}.keyword`,
                    react: [],
                    aggregate: true,
                    shouldAggregate: (filters) => {
                        const allCategories = f.categories.flatMap(
                            (category) => {
                                const cat = categoryTree.find(
                                    (c) => c.title.en === category
                                )
                                // console.log('CAT IS', cat)
                                const subCats = cat
                                    ? cat.subCategories.map((s) => s.title.en)
                                    : []
                                return [category, ...subCats]
                            }
                        )
                        const categoryFacet = filters.find(
                            (filter) => filter.name === 'Categories'
                        )
                        return (
                            _.intersection(
                                categoryFacet.value || [],
                                allCategories
                            ).length > 0
                        )
                    }
                }
            })
            this.facets = [
                {
                    name: 'Search',
                    type: 'custom',
                    query: (v) => ({
                        bool: {
                            should: [
                                {
                                    match: {
                                        name_es: {
                                            query: v,
                                            fuzziness: 0
                                        }
                                    }
                                },
                                {
                                    term: {
                                        pn: v
                                    }
                                }
                            ]
                        }
                    }),
                    react: [],
                    aggregate: false
                },
                {
                    name: 'Categories',
                    property: 'categories',
                    type: 'multiple',
                    react: [],
                    aggregate: false
                },
                ...dynamicFacets
            ]
        }
    }
}
</script>
<style scoped>
.v-expansion-panel-header{
    padding: 0px 10px !important;
}
.v-expansion-panel-content>>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
  min-height: 38px;
}
</style>
